import React from "react";
import {
  FlatList,
  View,
  StyleSheet,
  ActivityIndicator,
  TouchableOpacity,
} from "react-native";
import Text from "@components/AppText";
import colors from "@constants/color";
import Caret from "@assets/svg/Caret";
// import analytics from "@services/analytics";

import t from "@constants/localization";
import OrderCard from "./OrderCard";

const PATH = "screens/SupportTree/components/OrderList/View/index";

const OrdersListView = ({
  orders,
  onPressOrder = () => {},
  contentContainerStyle = {},
  loading,
  selectButtonText,
  navigation,
  showUserName = true,
  onScroll = () => {},
  userId = null,
  isPulled = false,
  pulledFunc = () => {},
  listRef = () => {},
}) => {
  const emptyComponent = () => {
    return (
      <View
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          padding: 20,
        }}
      >
        <TouchableOpacity
          onPress={() => {
            navigation.goBack();
          }}
        >
          <View style={[styles.btnContainer, { flexDirection: "column" }]}>
            <Text fontType="content1" style={{ paddingBottom: 20 }}>
              {t(`${PATH}/noOrders`)}
            </Text>
          </View>
        </TouchableOpacity>
      </View>
    );
  };

  return (
    <>
      {!orders.length && loading ? (
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ActivityIndicator size="large" color={colors.primary} />
        </View>
      ) : (
        <FlatList
          data={orders}
          keyExtractor={(item) => item.order_id}
          ref={(view) => {
            listRef(view);
          }}
          showsVerticalScrollIndicator={false}
          renderItem={({ item, index }) => {
            return (
              <OrderCard
                order={item}
                showUserName={showUserName}
                onPressOrder={onPressOrder}
                selectButtonText={selectButtonText}
              />
            );
          }}
          onScroll={onScroll}
          ListEmptyComponent={emptyComponent()}
          contentContainerStyle={{
            ...contentContainerStyle,
            flex: orders.length > 0 ? 0 : 1,
            paddingBottom: 50,
          }}
          onEndReachedThreshold={0.1}
          ListFooterComponent={() =>
            orders.length && loading ? (
              <ActivityIndicator size="large" color={colors.primary} />
            ) : (
              <></>
            )
          }
        />
      )}
    </>
  );
};

export default OrdersListView;

const styles = StyleSheet.create({
  btnContainer: {
    padding: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
});
